export const mapOptions = {
    panControl: false,
    mapTypeControl: false,
    scrollwheel: false,
    disableDefaultUI: true,
    styles: [
{
"featureType": "water",
"elementType": "geometry",
"stylers": [
  {
      "color": "#111130"
  },
  {
      "lightness": 17
  }
]
},
{
"featureType": "landscape",
"elementType": "geometry",
"stylers": [
  {
      "color": "#111130"
  },
  {
      "lightness": 20
  }
]
},
{
"featureType": "road.highway",
"elementType": "geometry.fill",
"stylers": [
  {
      "color": "#111130"
  },
  {
      "lightness": 17
  }
]
},
{
"featureType": "road",
"elementType": "geometry.stroke",
"stylers": [
  {
      "visibility": "off"
  }
]
},
{
"featureType": "road.highway.controlled_access",
"elementType": "geometry.stroke",
"stylers": [
  {
      "color": "#111130"
  },
  {
      "lightness": 20
  }
]
},
{
"featureType": "road.arterial",
"elementType": "geometry",
"stylers": [
  {
      "color": "#111130"
  },
  {
      "lightness": 25
  }
]
},
{
"featureType": "road.local",
"elementType": "geometry",
"stylers": [
  {
      "color": "#111130"
  },
  {
      "lightness": 25
  }
]
},
{
"featureType": "poi",
"elementType": "geometry",
"stylers": [
  {
      "color": "#111130"
  },
  {
      "lightness": 21
  }
]
},
{
"elementType": "labels.text.stroke",
"stylers": [
  {
      "visibility": "off"
  }
]
},
{
"elementType": "labels.text.fill",
"stylers": [
  {
      "saturation": 0
  },
  {
      "color": "#BBBBBB"
  },
  {
      "lightness": 0
  }
]
},
{
"elementType": "labels.icon",
"stylers": [
  {
      "visibility": "off"
  }
]
},
{
"featureType": "transit",
"elementType": "geometry",
"stylers": [
  {
      "color": "#111130"
  },
  {
      "lightness": 19
  }
]
},
{
"featureType": "administrative",
"elementType": "geometry.fill",
"stylers": [
  {
      "color": "#111130"
  },
  {
      "lightness": 20
  }
]
},
{
"featureType": "administrative",
"elementType": "geometry.stroke",
"stylers": [
  {
      "color": "#111130"
  },
  {
      "lightness": 17
  },
  {
      "weight": 1.2
  }
]
}
]

}

